const routes = {
    LOGIN: '/',
    DASHBOARD: '/dashboard'
};

export { routes };
